import React from 'react'
import StudentsCourses from '../../features/trainer/StudentsCourses'
const TrainerStudentsCoursesPage = () => {
  return <StudentsCourses/>
}

export default TrainerStudentsCoursesPage